import { Routes } from '@angular/router';
import { RoleGuardService } from './initial/initial-role-guard';
import { InitialComponent } from './initial/initial.component';
import { InitialAuthGuard } from './initial/initial.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: InitialComponent,
    canActivate: [InitialAuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

      {
        path: 'clinics',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./clinics/clinics-routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'user',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'provider', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./clinics/clinics-routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'dashboard',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'provider', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./dashboard/dashboard-routing.module').then((m) => m.DashboardRoutingModule),
      },
      {
        path: 'planner',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./planner/planner.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'provider',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner','billing user', 'billing manager'] },
        loadChildren: () =>
          import('./provider/provider.routing.module').then((m) => m.ProviderRoutingModule),
      },
      {
        path: 'skills',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./skills/skills.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'spots',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./spots/spots.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'billing-codes',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./billing-codes/billing.routing.module').then((m) => m.BillingRoutingModule),
      },
      {
        path: 'fee-schedules',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./fee-schedule/fee-schedule-routing.module').then(
            (m) => m.FeeScheduleRoutingModule
          ),
      },
      {
        path: 'payors',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./payers/payers-routing.module').then((m) => m.PayersRoutingModule),
      },
      {
        path: 'billing-rules',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./billing-rcm/pages/billing-rules/billing-rules-routing.module').then((m) => m.BillingRulesRoutingModule),
      },
      {
        path: 'billing-facilities',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./billing-rcm/pages/billing-facilities/billing-facilities-routing.module').then((m) => m.BillingFacilitiesRoutingModule),
      },
      {
        path: 'provider-networks',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./billing-rcm/pages/provider-networks/provider-networks-routing.module').then(
            (m) => m.ProviderNetworksRoutingModule,
          ),
      },
      {
        path: 'payments',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./payments/payments.routing.module').then((m) => m.PaymentsRoutingModule),
      },
      {
        path: 'encounters',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./encounters/encounters-routing.module').then((m) => m.EncountersRoutingModule),
      },
      {
        path: 'billing-rcm',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./billing-rcm/billing-rcm.module').then((m) => m.BillingRcmModule),
      },
      {
        path: 'records',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./billing-rcm/pages/work-queue/work-queue-routing.module').then((m) => m.ClaimRecordsRoutingModule),
      },
      {
        path: 'patient-ar',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./billing-rcm/pages/patient-ar/patient-ar-routing.module').then((m) => m.PatientArRoutingModule),
      },
      {
        path: 'contracts',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./contracts/contracts-routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'solver',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./solver/solver.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'patient',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./patient/patient.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'patient-team',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./patient-team/patient-team.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'availability',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'provider', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./availability/availability.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'scheduling',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'provider', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./scheduling/scheduling.routing').then((m) => m.schedulingRoutes),
      },
      {
        path: 'therapygroup',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./behaviourtherapygroup/therapygroup.routing.module').then(
            (m) => m.ContactRoutingModule
          ),
      },
      {
        path: 'holidays',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'provider', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./holidays/holidays-routing.module').then((m) => m.HolidaysRoutingModule),
      },
      {
        path: 'error',
        loadChildren: () => import('./error/error.module').then((m) => m.ErrorModule),
      },
      {
        path: 'setting',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./setting/setting-routing.module').then((m) => m.SettingRoutingModule),
      },
      {
        path: 'job-config',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin','billing user', 'billing manager'] },
        loadChildren: () =>
          import('./job-config/job-config-routing.module').then((m) => m.JobConfigRoutingModule),
      },
      {
        path: 'trash',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'billing user', 'billing manager'] },
        loadChildren: () =>
          import('./job-config/trash-component/trash/trash-routing.module').then(
            (m) => m.TrashRoutingModule
          ),
      },
      {
        path: 'tasks',
        canActivate: [RoleGuardService],
        data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'provider', 'billing user', 'billing manager'] },
        loadChildren: () => import('./tasks/tasks.module').then((m) => m.TasksModule),
      },
      // {
      //   path: 'chat',
      //   canActivate: [RoleGuardService],
      //   data: { expectedRoles: ['superAdmin', 'manager', 'planner', 'provider'] },
      //   loadChildren: () => import('./chat/chat-routing.module').then((m) => m.ChatRoutingModule),
      // },
    ],
  },
  {
    path: 'login',
    // component: LoginComponent,
    loadComponent: () =>
      import('./authenticate/login/login.component').then((m) => m.LoginComponent),
    //  canActivate: [loginRedirectGuard]
  },
  {
    path: 'forgot',
    // component: ForgotPasswordComponent,
    loadComponent: () =>
      import('./authenticate/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'forget-email-password/:user_id/:hash',
    // component: ResetPasswordComponent,
    loadComponent: () =>
      import('./authenticate/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: 'reset-password/:user_id',
    // component: ResetPasswordComponent,
    loadComponent: () =>
      import('./authenticate/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
